/** The 20 latest SatNOGS observations, each linking to network.satnogs.org (loader-satnogs-telem.js). */
import { cn } from '@/lib/cn';
import { OBSERVATION_LIMIT, observationUrl } from '../../../awareness/satnogs';
import { useAwareness } from '../../../awareness/store';
import { ErrorLine, Muted } from './Section';
import { hhmmZ } from './shared';

function statusTone(status: string): string {
  return status === 'good' ? 'text-nominal' : status === 'bad' ? 'text-warning' : 'text-ink-3';
}

export function SatNogsPanel() {
  const state = useAwareness((s) => s.satnogs);
  if (!state) return <Muted>Loading observations.</Muted>;
  return (
    <div className="flex flex-col gap-1">
      {state.error && <ErrorLine text={`Feed unavailable: ${state.error}`} />}
      {state.observations.length === 0 && !state.error && <Muted>No recent observations</Muted>}
      {state.observations.length > 0 && (
        <ul className="flex flex-col">
          {state.observations.slice(0, OBSERVATION_LIMIT).map((o) => (
            <li key={o.id}>
              <a
                href={observationUrl(o.id)}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-baseline gap-2 rounded-control px-1.5 py-1 hover:bg-overlay"
              >
                <span className={cn('h-1.5 w-1.5 shrink-0 self-center rounded-full bg-current', statusTone(o.status))} title={o.status} />
                <span className="w-12 shrink-0 font-mono text-[10px] text-ink-3">{hhmmZ(o.startMs)}</span>
                <span className="flex-1 truncate text-ink">{o.satellite}</span>
                <span className="shrink-0 text-[10px] text-ink-3">stn {o.stationId ?? '?'}</span>
              </a>
            </li>
          ))}
        </ul>
      )}
      <div className="text-[10px] text-ink-3">
        {state.stationCount} stations indexed, polled every 60 s
        {state.updatedMs !== null ? `, updated ${hhmmZ(state.updatedMs)}` : ''}
      </div>
    </div>
  );
}
